import { createGroupApiClient } from "../lib/apiClient";

const api = createGroupApiClient();

export const fetchGroups = () => api.get("");

export const fetchGroup = ({ queryKey }) => {
  const groupId = queryKey[1];
  return api.get(`/${groupId}`);
};

export const fetchGroupsByOrganisationId = ({ queryKey }) => {
  const organisationId = queryKey[1];
  return api.get(`/organisation/${organisationId}`);
};

export const createGroup = (groupData) => api.post("", groupData);

export const updateUserGroup = (groupId, groupData) =>
  api.put(`/${groupId}`, groupData);

export const deleteGroup = (groupId) => {
  if (groupId === undefined) {
    return undefined;
  }
  return api.delete(`/${groupId}`);
};
